import nowadaysIcon from "@/app/(public)/shared/assets/nowadays-icon.png";

const SIZES = {
  sm: "size-12 rounded-xl p-1.5",
  md: "size-16 rounded-2xl p-2",
  lg: "size-20 md:size-28 rounded-3xl p-3 md:p-4",
} as const;

/** Competitor logos are mostly wordmarks, so their tiles run wide at the same height. */
const WIDE_SIZES = {
  sm: "h-12 w-24 rounded-xl px-3 py-2",
  md: "h-16 w-32 rounded-2xl px-4 py-3",
  lg: "h-20 w-36 md:h-28 md:w-52 rounded-3xl px-5 py-4 md:px-7 md:py-6",
} as const;

interface LogoTileProps {
  /** Competitor logo; omit for the Nowadays mark. */
  logo?: { url: string; alt: string };
  size: keyof typeof SIZES;
}

/**
 * Square white tile holding a brand logo, used in "X vs Nowadays" lockups.
 * @param props - competitor `logo` (Nowadays when omitted) and tile `size`
 * @returns the logo tile
 */
export default function LogoTile({ logo, size }: LogoTileProps) {
  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden border border-landing-primary bg-white shadow-[0_1px_3px_0_oklch(0.4_0.02_280/0.05)] ${logo ? WIDE_SIZES[size] : SIZES[size]}`}
    >
      <img
        src={logo?.url ?? nowadaysIcon.src}
        alt={logo?.alt ?? "Nowadays"}
        className="size-full object-contain"
        loading="lazy"
      />
    </div>
  );
}
